<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar
        title="附件列表"
        left-text="返回"
        left-arrow
        @click-left="goback"
      />
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="item in fileList" :key="item.id">
        <template #title>
          <span class="custom-title">{{item.fileName}}</span>
        </template>
        <template #right-icon>
          <van-button
            type="info"
            size="mini"
            v-if="fileTypeList.includes(item.fileType)"
            @click="preview(item)"
            >预览</van-button
          >
          <van-button type="primary" size="mini" @click="download(item)"
            >下载</van-button
          >
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      ids: this.$route.query.attachmentIds,
      fileList: [],
      fileTypeList: ["jpeg", "png", "jpg", "webp", "gif", "bmp", "tiff"],
    };
  },
  methods: {
    download(file) {
      this.axios({
        url: "/attachment/download",
        method: "get",
        params: {
          fileUrl: file.fileUrl,
        },
        responseType: "blob",
      }).then((res) => {
        let filename = file.fileName;
        const link = document.createElement("a");
        let blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute(
          "download",
          decodeURI(
            filename.substring(filename.indexOf("=") + 1, filename.length)
          )
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    preview(item) {
      this.axios({
        url: "/attachment/download",
        method: "get",
        params: {
          fileUrl: item.fileUrl,
        },
        responseType: "blob",
      }).then((res) => {
        const url = URL.createObjectURL(res.data);
        ImagePreview([url]);
      });
    },
    goback() {
      this.$router.go(-1);
    },
    onLoad() {
      this.loading = true;
      this.getFileList();
    },
    // 获取文件列表
    getFileList() {
      this.axios({
        url: "/attachment/list",
        method: "post",
        data: {
          ids: this.ids,
        },
      }).then((res) => {
        this.fileList = res.data.data;
        this.loading = false;
        this.finished = true;
        console.log(this.fileList);
      });
    },
  },
};
</script>

<style scoped>
.custom-title{
  display: inline-block;
  max-width: 310px;
  word-wrap: break-word;
}
</style>